import { Box, Button, Text } from '@vouched.id/vault';
import React, { useCallback, useState } from 'react';
import ReactJson from 'react-json-view';
import { copyHandler } from '../../utils';
import { Dropdown } from '../Dropdown';
import { useGlobalState } from 'store/reducers/reducer';
import { adminRerunJob } from 'store/sagas/sagas';
import { getSelectedTemplateId } from 'utils/jobs';
export const RerunJobDropdown = ({ jobSid }) => {
    const { asyncDispatch } = useGlobalState();
    const [rerunDebugResults, setRerunDebugResults] = useState();
    const [templateId, setTemplateId] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const handleRerunJob = useCallback(() => {
        setIsLoading(true);
        setRerunDebugResults(undefined);
        asyncDispatch(adminRerunJob(jobSid))
            .then((result) => {
            let parsedDebugResults;
            try {
                parsedDebugResults = result.debugResults
                    ? JSON.parse(result.debugResults)
                    : { results: 'No debug results available' };
            }
            catch {
                parsedDebugResults = { results: 'Unable to parse debug results' };
            }
            const success = !!result.result?.success;
            setRerunDebugResults({
                replayResult: {
                    success
                },
                replayDebug: parsedDebugResults
            });
            setTemplateId(getSelectedTemplateId(parsedDebugResults));
            setIsLoading(false);
        })
            .catch((error) => {
            console.error('Error rerunning job:', error);
        });
    }, [jobSid]);
    return (React.createElement(Dropdown, { title: "Rerun Job" },
        React.createElement(Text, { style: { marginBottom: '15px' } }, "Click the button below to rerun this job."),
        React.createElement(Button, { disabled: isLoading, onClick: handleRerunJob, title: isLoading ? 'loading' : '' }, "Rerun"),
        rerunDebugResults && (React.createElement(Box, null,
            templateId && (React.createElement(Box, { marginY: "spacing.default" },
                React.createElement("a", { className: "job-modal__debug__template-link", href: `/admin/templates/${templateId}`, rel: "noreferrer", target: "_blank" }, "Link to the template used for this ID"))),
            React.createElement("div", { "data-ph-mask": true },
                React.createElement(ReactJson, { enableClipboard: copyHandler, src: rerunDebugResults }))))));
};
